module.exports = __webpack_public_path__ + "static/logo-celsious-7131258aa3b9d707bc1534c8cd956082.png";